import { useState } from 'react'
import { COLOR_MAP } from '../../../common/utils/theme'
import './circle.css'
import { formatDecimals } from '../../../common/utils/helper'

const CircleRating = ({
  value,
  totalCircles = 10,
  size = 16,
  emptyColor = 'transparent',
  countryCode,
  pillar,
  pillarValue,
}) => {
  const [isHovered, setIsHovered] = useState(false)

  // Calculate full circles and percentage fill for the last circle
  const fullCircles = Math.floor(value)
  const lastCircleFill = value - fullCircles // Fractional part for the partially filled circle

  const renderCircles = () => {
    let circles = []
    let i = 0

    // Render fully filled circles
    for (i = 0; i < fullCircles; i++) {
      circles.push(
        <circle
          key={`${countryCode}-${pillar}-full-${i}`}
          cx={i >= 5 ? (size + 5) * (i - 4) - 12 : (size + 5) * (i + 1) - 12}
          cy={i >= 5 ? size / 2 + size + 5 : size / 2 + 2}
          r={size / 2}
          fill={COLOR_MAP[pillar]}
        />
      )
    }

    // Render the partially filled circle if needed
    if (lastCircleFill > 0 && fullCircles < totalCircles) {
      const grad_id = `gradientFill-${countryCode}-${pillar}-${lastCircleFill}`
      const gradFill = `url(#${grad_id})`
      circles.push(
        <svg key={`svg-${countryCode}-${pillar}-${i}`}>
          <defs>
            <linearGradient id={grad_id} x1="0%" y1="0%" x2="100%" y2="0%">
              <stop offset="0%" stopColor={COLOR_MAP[pillar]} />
              <stop
                offset={lastCircleFill}
                stopColor={COLOR_MAP[pillar]}
                stopOpacity="1"
              />
              <stop
                offset={lastCircleFill}
                stopColor={emptyColor}
                stopOpacity="1"
              />
              <stop offset="100%" stopColor={emptyColor} stopOpacity="1" />
            </linearGradient>
          </defs>
          <circle
            //key={fullCircles}
            cx={i >= 5 ? (size + 5) * (i - 4) - 12 : (size + 5) * (i + 1) - 12}
            cy={i + 1 > 5 ? size / 2 + size + 5 : size / 2 + 2}
            r={size / 2}
            fill={gradFill}
            stroke="lightgray"
          />
        </svg>
      )
    }

    // Render the remaining empty circles
    for (
      let i = lastCircleFill === 0 ? fullCircles : fullCircles + 1;
      i < totalCircles;
      i++
    ) {
      circles.push(
        <circle
          key={`${countryCode}-${pillar}-empty-${i}`}
          cx={i >= 5 ? (size + 5) * (i - 4) - 12 : (size + 5) * (i + 1) - 12}
          cy={i >= 5 ? size / 2 + size + 5 : size / 2 + 2}
          r={size / 2}
          fill={emptyColor}
          stroke="lightgray"
        />
      )
    }

    return circles
  }

  return (
    <>
      <svg
        height="40"
        width={size * 7}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        {renderCircles()}
      </svg>
      {isHovered && (
        <div className="topic-tooltip">
          Score: {formatDecimals(pillarValue)}
        </div>
      )}
    </>
  )
}

export default CircleRating
